import React, {
  useState,
  useEffect,
  useRef,
  memo,
  useCallback,
} from 'react';
import classnames from 'classnames';
import { Event } from '../../../socketProvider';

import { streamToBase64 } from '../../../helpers/utils';
import { socketEventNames } from '../../../helpers/constants';

import InfoBar from './InfoBar';
import Controls from './Controls';
import SnapshotAnimation from './SnapshotAnimation';
import StreamImage from './StreamImage';

import style from './style.module.scss';

const { MONITOR_LIVESTREAM } = socketEventNames;
const initialStreamState = { image: null, fps: 0 };

const Camera = ({ selected, name: cameraName, controlsEnabled = true }) => {
  const timeoutRef = useRef();
  const frameCountRef = useRef(0);
  const [stream, setStream] = useState(initialStreamState);
  const [actualFps, setActualFps] = useState(0);

  const resetFpsCounter = useCallback(() => {
    const fps = frameCountRef.current / 10;
    console.log('Calculated FPS for', cameraName, ':', fps.toFixed(1), 'fps (', frameCountRef.current, 'frames in 10s)');
    setActualFps(fps);
    frameCountRef.current = 0;
  }, [cameraName]);

  const handleLivestream = useCallback((camera, binary, hostname, fps) => {
    if (camera === cameraName) {
      frameCountRef.current += 1;

      setStream({ image: streamToBase64(binary), fps: fps || 0 });

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => setStream(initialStreamState), 15 * 1000);
    }
  }, [cameraName]);

  useEffect(() => {
    setStream(initialStreamState);
    frameCountRef.current = 0;
    setActualFps(0);
  }, [cameraName]);

  useEffect(() => {
    const interval = setInterval(() => {
      resetFpsCounter();
    }, 10000);

    return () => clearInterval(interval);
  }, [resetFpsCounter]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <>
      <Event event={MONITOR_LIVESTREAM} handler={handleLivestream} />
      <div className={classnames('camera', style.camera, { [style.selected]: selected })}>
        <div className={style.stream}>
          <StreamImage src={stream.image} camKey={cameraName} />
        </div>

        {!stream.image && (
          <div className={style.camPlaceholder}>
            <i className="ion ion-ios-videocam" />
            <h4>CAMERA OFF</h4>
          </div>
        )}
        {controlsEnabled && (
          <InfoBar cameraName={cameraName} fps={stream.fps} actualFps={actualFps} />
        )}
        {controlsEnabled && <Controls cameraName={cameraName} />}
        {controlsEnabled && <SnapshotAnimation cameraName={cameraName} />}
      </div>
    </>
  );
};

export default memo(Camera);
